import React from 'react';
import { ClipboardList } from 'lucide-react';

const FieldResearchSection = ({ fieldResearch }) => {
  if (!fieldResearch || fieldResearch.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <ClipboardList className="w-6 h-6 text-blue-500" />
        <h2 className="text-2xl font-bold text-gray-800">Field Research</h2>
      </div>
      
      <div className="space-y-4">
        {fieldResearch.map((research, index) => (
          <div
            key={index}
            className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50 rounded-r-lg"
          >
            <p className="font-medium text-gray-800 mb-1">
              {research.task || 'Complete task'}
            </p>
            <p className="text-gray-600 text-sm">
              Reward: {research.reward || 'Unknown'}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FieldResearchSection;
